import type { VolopSource } from 'utils/constants/general/volopSources';

export const EMBED_SEARCH_WIDGET_VOLOP_SOURCES_ALLOWED = [
  'GOLDEN',
  'IDEALIST',
] satisfies VolopSource[];
